export interface Language {
  code: string
  name: string
  flag: string
}

export const LANGUAGES: Language[] = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'ja', name: 'Japanese', flag: '🇯🇵' },
  { code: 'vi', name: 'Vietnamese', flag: '🇻🇳' },
]

const LANG_CODES = new Set(LANGUAGES.map((l) => l.code))

export function sanitizeLanguageCode(code: unknown, fallback: string): string {
  if (code === '') return ''
  if (!code || typeof code !== 'string') return fallback
  return LANG_CODES.has(code) ? code : fallback
}

export function getLanguage(code: string): Language {
  if (!code) {
    return { code: '', name: 'Auto-detect', flag: '🌐' }
  }
  return (
    LANGUAGES.find((lang) => lang.code === code) ??
    LANGUAGES.find((l) => l.code === 'en') ??
    LANGUAGES[0]
  )
}

export function formatLanguageCode(code: string): string {
  return code ? code.slice(0, 2).toUpperCase() : 'AUTO'
}
